import { useFieldOperationsSettings } from './context/FieldOperationsSettingsContext';

export {
  FieldOperationsSettingsProvider,
  useFieldOperationsSettings,
} from './context/FieldOperationsSettingsContext';

export const useFieldOperationsModuleVisible = (): boolean => {
  const { isModuleEnabled } = useFieldOperationsSettings();
  return isModuleEnabled;
};
